import React from 'react'
import { Box, Typography, Alert } from '@mui/material'

/**
 * Payout Section Component - STUB
 * TODO: Implement payout model selection and banking details form
 */
export default function PayoutSection({ data, onChange, disabled, loading, error }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Payout Model & Banking
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        TODO: Implement payout model (retainer/share/per-session) and banking form
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Alert severity="info">
        This section needs implementation. See SPRINT.md for details.
      </Alert>
    </Box>
  )
}
